let map;
let markers = [];
const mapElement = document.getElementById("google_map");

async function initMap() {
  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  const cards = document.querySelectorAll(
    ".store-locator__map-layout .store-locator-card"
  );

  const storeLongitude = Array.from(
    document.querySelectorAll(".store-locator-card__longitude")
  ).map((item) => item.textContent);
  const storeLatitude = Array.from(
    document.querySelectorAll(".store-locator-card__latitude")
  ).map((item) => item.textContent);
  const coordinateTitle = Array.from(
    document.querySelectorAll(".store-locator-card__coordinate-title")
  )
    .map((item) => item.textContent)
    .map((item) => item.replace(/([A-Z])/g, " $1").trim());

  const coordinateAddress = Array.from(
    document.querySelectorAll(".store-locator-card__address")
  ).map((item) => item.textContent);
  const coordinateHours = Array.from(
    document.querySelectorAll(".store-locator-card__opening-hour")
  ).map((item) => item.innerHTML);
  const coordinateButtons = Array.from(
    document.querySelectorAll(".store-locator-card__actions")
  ).map((item) => item.innerHTML);

  const mapZoomLevel =
    Number(document.getElementById("google_map").dataset.mapZoomLevel) || 4;
  const mapZoomLevelUnit = mapZoomLevel <= 18 ? 3 : 0;

  const locations = [];

  for (let i = 0; i < storeLongitude.length; i++) {
    const coordinateIndex = i;
    const coordinatLatitude = Number(storeLatitude[coordinateIndex]);
    const coordinateT = coordinateTitle[coordinateIndex];
    const coordinateA = coordinateAddress[coordinateIndex];
    const tooltipContent =
      coordinateA && !coordinateT ? coordinateA : coordinateT;

    if (coordinatLatitude && (tooltipContent || "n/a")) {
      locations.push([
        `<b>${tooltipContent}</b><br/><a href="https://maps.google.com/?q=${coordinatLatitude},${Number(
          storeLongitude[i]
        )}" target="_blank" style="text-decoration: underline;">Location</a>`,
        coordinatLatitude,
        Number(storeLongitude[i]),
      ]);
    }
  }

  const minLongitude = Math.min(...storeLongitude);
  const minLatitude = Math.min(...storeLatitude);
  const maxLongitude = Math.max(...storeLongitude);
  const maxLatitude = Math.max(...storeLatitude);

  const centerLatitude = (minLatitude + maxLatitude) / 2;
  const centerLongitude = (minLongitude + maxLongitude) / 2;

  if (typeof google === "undefined" || typeof google.maps === "undefined") {
    return;
  }

  map = new Map(mapElement, {
    zoom: mapZoomLevel,
    center: { lat: centerLatitude, lng: centerLongitude },
    scrollwheel: true,
    gestureHandling: "greedy",
    disableDefaultUI: true,
    backgroundColor: "#89b4f8",
    mapId: "4504f8b37365c3d0",
  });

  const pinIcon = {
    url: mapElement.dataset.mapPinIcon,
  };

  const infowindow = new google.maps.InfoWindow({
    maxWidth: 200,
  });

  const setMapClickHandler = (item, i) => {
    item.addEventListener("click", function () {
      map.panTo(new google.maps.LatLng(locations[i][1], locations[i][2]));
      map.setZoom(mapZoomLevel + mapZoomLevelUnit);
    });
    console.log("clicked")
  };

  for (let i = 0; i < locations.length; i++) {
    setMapClickHandler(cards[i], i);

    const customMarker = document.createElement("div");
    const customMarkerLabel = document.createElement("div");
    const customMarkerPoint = document.createElement("div");
    const openingHoursLabel = document.createElement("div");
    const buttonsLabel = document.createElement("div");

    customMarker.className = "store-locator__map--custom-marker";
    customMarker.setAttribute("id", `store-locator__map--custom-marker--${i}`);

    customMarkerLabel.className = "store-locator__map--custom-marker--label";
    customMarkerLabel.textContent = coordinateTitle[i];

    customMarkerPoint.className = "store-locator__map--custom-marker--point";

    openingHoursLabel.className = "store-locator__map--custom-marker--hours";
    openingHoursLabel.innerHTML = coordinateHours[i];

    buttonsLabel.className = "store-locator__map--custom-marker--buttons";
    buttonsLabel.innerHTML = coordinateButtons[i];

    //customMarker.appendChild(customMarkerLabel);
    customMarker.appendChild(customMarkerPoint);
    customMarkerLabel.appendChild(openingHoursLabel);
    customMarkerLabel.appendChild(buttonsLabel);

    const mapPin = document.getElementById("icon-pin-template");
    const customPin = document.createElement("div");
    customPin.className = "store-locator__custom-map__custom-pin";
    customPin.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 30 30">
      <!-- Pin-Form -->
      <path d="M15 2C10 2 6 6 6 11c0 6 9 16 9 16s9-10 9-16c0-5-4-9-9-9z" fill="#ff0000"/>
      
      <!-- Inneres Loch (leicht dunkleres Rot) -->
      <circle cx="15" cy="11" r="3.5" fill="#b30000"/>
    </svg>
    `;
    customPin.setAttribute("id", `store-locator__map--custom-marker--${i}`);


    const marker = new AdvancedMarkerElement({
      position: new google.maps.LatLng(locations[i][1], locations[i][2]),
      map,
      content: customPin,
    });

    markers = [...markers, marker];

    google.maps.event.addListener(
      marker,
      "click",
      (function (marker, count) {
        return function () {
          if (window.innerWidth <= 750) {
            // Mobile: Pin im oberen Viertel positionieren (stabil, unabhängig vom Zoom)
            const markerPosition = new google.maps.LatLng(
              locations[i][1],
              locations[i][2]
            );
            
            // Hole die aktuellen Viewport-Bounds
            const bounds = map.getBounds();
            if (bounds) {
              const ne = bounds.getNorthEast();
              const sw = bounds.getSouthWest();
              
              // Berechne die Höhe des sichtbaren Bereichs in Grad
              const viewportHeightDegrees = ne.lat() - sw.lat();
              
              // Ziel: Marker soll bei 25% von oben sein (im oberen Viertel)
              // Um den Marker im oberen Viertel zu positionieren, muss der Center
              // nach unten verschoben werden (subtrahieren), damit der Marker relativ
              // zum Viewport oben bleibt
              const offsetDegrees = viewportHeightDegrees * 0.25;
              
              const newCenter = new google.maps.LatLng(
                markerPosition.lat() - offsetDegrees, // Minus, um Center nach unten zu verschieben
                markerPosition.lng()
              );
              
              map.panTo(newCenter);
            } else {
              // Fallback: Falls bounds nicht verfügbar sind
              map.panTo(markerPosition);
            }
          } else {
            // Desktop: Zentriert ohne Offset
            const newLatLng = new google.maps.LatLng(
              locations[i][1],
              locations[i][2]
            );
            map.panTo(newLatLng);
          }

          /** display active marker styles */
          document
            .querySelectorAll(".store-locator__custom-map__custom-pin")
            .forEach((item) => item.classList.remove("active"));
          document
            .getElementById(`store-locator__map--custom-marker--${count}`)
            .classList.add("active");

          /** display selected marker's pin card */
          const mapWithSearch = document
            .querySelector(".store-locator__map-layout")
            .classList.contains("store-locator__map-layout--with-search");
          if (!mapWithSearch || window.innerWidth < 750) {
            document
              .querySelectorAll(
                ".store-locator__map-layout .store-locator-card"
              )
              .forEach((card) => (card.style.display = "none"));
            document.querySelector(
              `[data-marker-index="${count}"]`
            ).style.display = "block";
          }
        };
      })(marker, i)
    );

    function removeMarkers() {
      /** remove active from all markers */
      document
        .querySelectorAll(".store-locator__map--custom-marker")
        .forEach((item) =>
          item.classList.remove("store-locator__map--custom-marker--active")
        );

      /** remove selected marker's pin card */
      document
        .querySelectorAll(".store-locator-card")
        .forEach((card) => card.removeAttribute("style"));
    }
  }
}

initMap();

const closeButtons = document.querySelectorAll(
  ".store-locator__map-layout .mobile-close-store-locator"
);
closeButtons.forEach((item) => {
  item.addEventListener("click", () => {
    document
      .querySelectorAll(".store-locator__map-layout .store-locator-card")
      .forEach((card) => {
        card.style.display = "none";
      });
  });
});
